import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Typography, Dropdown, Avatar } from 'antd';
import { 
  MenuUnfoldOutlined, MenuFoldOutlined, 
  FileOutlined, UserOutlined, LogoutOutlined 
} from '@ant-design/icons';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // 简化token检查 - 只检查token是否存在
  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem('token');
      if (!token) {
        handleLogout();
        return;
      }
    };

    checkToken();

    // 每分钟检查一次token是否存在
    const intervalId = setInterval(checkToken, 60000);

    return () => clearInterval(intervalId);
  });

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: '/admin/licenses',
      icon: <FileOutlined />,
      label: <Link to="/admin/licenses">营业执照管理</Link>,
    },
  ];

  const userMenu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  const selectedKey = location.pathname;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => {
          setCollapsed(broken);
        }}
      >
        <div className="logo">
          <Title level={collapsed ? 5 : 4} style={{ color: '#fff', margin: 0 }}>
            营业执照管理系统
          </Title>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['/admin/licenses']}
          selectedKeys={[selectedKey]}
          items={menuItems}
        />
      </Sider>
      <Layout className="site-layout">
        <Header className="site-layout-header">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            className="toggle-button"
          />
          <Dropdown menu={userMenu} placement="bottomRight">
            <div className="header-right">
              <Avatar icon={<UserOutlined />} />
              <span style={{ marginLeft: 8 }}>{user?.username || '管理员'}</span>
            </div>
          </Dropdown>
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: '#f0f2f5',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default AdminLayout; 